import styled from "styled-components";
import theme from "../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${theme.colors.brown.capivara};
  place-content: center;
  align-items: center;
  .lbl {
    font-size: ${theme.fontSize.xlg};
    font-family: sans-serif;
    font-weight: bolder;
  }
  .btns {
    margin-top: 5vh;
  }
`;
export const Logo = styled.div`
  display: flex;
  justify-content: center;
  img {
    max-width: 250px;
    height: auto;
  }
`;
